/* eslint-disable no-sequences */
import React from 'react';
import _, { isFunction } from 'lodash';
import { Button, ButtonGroup, Checkbox, Icon, Table } from 'semantic-ui-react';

import * as Constants from 'mpm-config/Constants';
import { FormattedMessage } from 'react-intl';

import PropTypes from 'prop-types';
import Utilities from 'mpm-config/Utilities';
import NumberFormat from 'react-number-format';

const NoDataFound = (props) => {
  return <div>{props.message ? props.message : 'No Data Found Ex'}</div>;
};

const MPMTable = ({ header, body, pagination, striped }) => {
  return (
    <>
      <Table unstackable size="small" striped={striped ? striped : true} className="customTable">
        <Table.Header>{header}</Table.Header>
        <Table.Body>{body}</Table.Body>
      </Table>
      {pagination}
    </>
  );
};

class SmartTable extends React.Component {
  constructor(props) {
    super(props);
    let header = props.header ? props.header : [];
    let data = props.data ? props.data : [];
    let rowsPerPage = props.rowsPerPage ? props.rowsPerPage : Constants.DEFAULT_TABLE_ROWS;
    this.state = {
      selectable: props.selectable ? props.selectable : false,
      header: header,
      defaultData: data,
      data: [],
      grouped: props.grouped ? props.grouped : false,
      groupeBy: props.groupeBy ? props.groupeBy : 'name',
      groupeSums: props.groupeSums ? props.groupeSums : ['size'],
      rowsPerPage: rowsPerPage,
      currentPage: 1,
      sortable: props.sortable ? props.sortable : true,
      sortColumn: props.sortColumn ? props.sortColumn : null,
      sortDirection: 'ascending',
      pagination: props.pagination === true ? true : false,
      totalPages: Math.ceil(data.length / rowsPerPage) > 0 ? Math.ceil(data.length / rowsPerPage) : 1,
      emptyMessage: props.emptyMessage || <FormattedMessage id="label.no-data-found" />,
      hideGroupIcon: props.hideGroupIcon ? true : false,
    };

    this.handleSort = this.handleSort.bind(this);
    this.onSelectRow = this.onSelectRow.bind(this);
    this.onSelectAllRows = this.onSelectAllRows.bind(this);
    this.onToggleGroupe = this.onToggleGroupe.bind(this);
    this.getValueOfRow = this.getValueOfRow.bind(this);
    this.initGroupingData = this.initGroupingData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.grouped) {
      this.initGroupingData(nextProps.data);
    } else {
      this.setState({
        defaultData: nextProps.data,
        totalPages: Math.ceil(nextProps.data.length / this.state.rowsPerPage) > 0 ? Math.ceil(nextProps.data.length / this.state.rowsPerPage) : 1,
      });
    }
  }

  getValueOfRow = (obj, prop, defval) => {
    if (typeof defval == 'undefined') defval = null;
    prop = prop.split('.');
    for (var i = 0; i < prop.length; i++) {
      if (typeof obj[prop[i]] == 'undefined') return defval;
      obj = obj[prop[i]];
    }
    return obj;
  };

  componentDidMount() {
    const { defaultData, grouped } = this.state;
    if (grouped) {
      this.initGroupingData(defaultData);
    } else {
      this.setState({
        data: defaultData,
      });
    }
  }
  initGroupingData = (defaultData) => {
    const { groupeBy, groupeSums, rowsPerPage } = this.state;
    let data = [];
    defaultData.forEach((rowData) => {
      let found = false;
      data.forEach((elem, index) => {
        if (elem.key[groupeBy] === this.getValueOfRow(rowData, groupeBy)) {
          found = true;
          elem.childrens.push(rowData);
          groupeSums.forEach((sumColumn) => {
            elem.key[sumColumn] = Utilities.cleanNumber(elem.key[sumColumn]) + Utilities.cleanNumber(rowData[sumColumn]);
          });
          data[index] = elem;
        }
      });

      if (!found) {
        let key = {
          open: false,
          [groupeBy]: this.getValueOfRow(rowData, groupeBy),
        };
        groupeSums.forEach((sumColumn) => {
          key[sumColumn] = rowData[sumColumn];
        });
        data.push({
          key,
          childrens: [rowData],
        });
      }
    });
    data = data.map((elem) => {
      groupeSums.forEach((sumColumn) => {
        elem.key[sumColumn] = <NumberFormat displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={elem.key[sumColumn]} />;
      });
      return elem;
    });
    this.setState({ data, totalPages: Math.ceil(data.length / rowsPerPage) });
  };

  handleSort = (clickedColumn) => () => {
    const { sortColumn, data, sortDirection } = this.state;

    if (sortColumn !== clickedColumn) {
      this.setState({
        sortColumn: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        sortDirection: 'ascending',
      });
      return;
    }
    this.setState({
      sortColumn: clickedColumn,
      data: data.reverse(),
      sortDirection: sortDirection === 'ascending' ? 'descending' : 'ascending',
    });
  };

  onSelectAllRows = () => {
    const { allRowsSelected, data } = this.state;
    data.map((row) => (row.selected = !allRowsSelected));
    let selected = [...data.filter((row) => row.selected)];
    let unselected = [...data.filter((row) => !row.selected)];
    unselected.map((elem) => {
      elem.quantite = 0;
      return elem;
    });
    selected.forEach((elem, index) => {
      if (elem.quantite === 0) {
        elem.quantite = elem.disponible;
      }
    });
    this.props.onSelectRows(selected);
    this.setState({
      data,
      allRowsSelected: !allRowsSelected,
    });
  };

  onSelectRow = (row) => {
    const { data } = this.state;
    const indexOfRow = data.indexOf(row);
    row.selected = row.selected ? false : true;
    if (!row.selected) {
      row.quantite = 0;
    }
    data[indexOfRow] = row;
    let selectedRows = data.filter((row) => row.selected);
    selectedRows.forEach((elem, index) => {
      if (elem.quantite === 0) {
        elem.quantite = elem.disponible;
      }
    });
    this.props.onSelectRows(selectedRows);
    this.setState({
      data,
      allRowsSelected: selectedRows.length === data.length,
    });
  };

  onToggleGroupe = (key, childrens, index) => {
    const { data } = this.state;
    key.open = !key.open;
    data[index] = { key, childrens };
    this.setState({ data });
  };

  render() {
    const { header, data, sortable, sortColumn, sortDirection, currentPage, totalPages, rowsPerPage, striped, selectable, allRowsSelected, grouped, pagination, emptyMessage, hideGroupIcon } = this.state;

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const visibleData = data.slice(indexOfFirstRow, indexOfLastRow);

    const renderRows =
      !grouped &&
      visibleData.map((row, index) => {
        return (
          <Table.Row active={row.selected || false} key={index}>
            {header.map((head, subIndex) => (
              <Table.Cell key={subIndex} textAlign={head.textAlign ? head.textAlign : 'left'} verticalAlign="middle" collapsing={head.collapsing} positive={head.positive && isFunction(head.positive) ? head.positive(row) : head.positive} negative={head.negative}>
                {head.component ? head.component(row) : this.getValueOfRow(row, head.selector)}
              </Table.Cell>
            ))}
            {selectable && (
              <Table.Cell collapsing verticalAlign="middle" textAlign="center">
                <Checkbox checked={row.selected} onChange={() => this.onSelectRow(row)} />
              </Table.Cell>
            )}
          </Table.Row>
        );
      });

    const renderGroupedRows =
      grouped &&
      visibleData.map(({ key, childrens }, index) => {
        return (
          <>
            <Table.Row active={key.open} key={index}>
              {grouped && !hideGroupIcon && (
                <Table.Cell collapsing verticalAlign="middle" textAlign="center">
                  <Button basic size="mini" icon onClick={() => this.onToggleGroupe(key, childrens, index)}>
                    {key.open ? <Icon name="chevron down" /> : <Icon name="chevron right" />}
                  </Button>
                </Table.Cell>
              )}
              {header.map((head) => (
                <Table.Cell textAlign={head.textAlign ? head.textAlign : 'left'} verticalAlign="middle" key={head.selector} collapsing={head.collapsing} positive={head.positive} negative={head.negative}>
                  {key[head.selector]}
                </Table.Cell>
              ))}
            </Table.Row>

            {key.open &&
              childrens.map((row) => (
                <Table.Row positive key={index}>
                  <Table.Cell />
                  {header.map((head) => (
                    <Table.Cell textAlign={head.textAlign ? head.textAlign : 'left'} verticalAlign="middle" key={head.selector} collapsing={head.collapsing} positive={head.positive} negative={head.negative}>
                      {head.component ? head.component(row) : this.getValueOfRow(row, head.selector)}
                    </Table.Cell>
                  ))}
                </Table.Row>
              ))}
          </>
        );
      });

    return (
      <>
        <Table celled sortable={sortable} size="small" striped={striped ? striped : true} unstackable={true} className="customTable unstackable">
          <Table.Header>
            <Table.Row>
              {header && (
                <>
                  {grouped && !hideGroupIcon && <Table.HeaderCell collapsing />}
                  {header.map((head, index) => {
                    return (
                      <Table.HeaderCell textAlign={head.textAlign ? head.textAlign : 'left'} verticalAlign="middle" sorted={sortColumn === head.selector ? sortDirection : null} key={index} onClick={this.handleSort(head.selector)}>
                        {' '}
                        {head.label}{' '}
                      </Table.HeaderCell>
                    );
                  })}
                  {selectable && !grouped && (
                    <Table.HeaderCell collapsing verticalAlign="middle" textAlign="center">
                      <Checkbox indeterminate={!allRowsSelected} checked={allRowsSelected} onChange={() => this.onSelectAllRows()} />
                    </Table.HeaderCell>
                  )}
                </>
              )}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data && data.length > 0 && grouped ? renderGroupedRows : renderRows}
            {data && data.length === 0 && (
              <Table.Row>
                <Table.Cell>{emptyMessage}</Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
        {pagination && (
          <ButtonGroup size="mini">
            <Button icon disabled={currentPage === 1} onClick={() => this.setState({ currentPage: currentPage - 1 })}>
              <Icon name="chevron left" />
            </Button>
            <Button basic>
              {currentPage} / {totalPages}
            </Button>
            <Button icon disabled={currentPage === totalPages} onClick={() => this.setState({ currentPage: currentPage + 1 })}>
              <Icon name="chevron right" />
            </Button>
          </ButtonGroup>
        )}
      </>
    );
  }
}

SmartTable.propTypes = {
  header: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  selectable: PropTypes.bool,
  grouped: PropTypes.bool,
  groupeBy: PropTypes.string,
  groupeSums: PropTypes.arrayOf(PropTypes.string),
  rowsPerPage: PropTypes.number,
  sortable: PropTypes.bool,
  sortColumn: PropTypes.string,
  pagination: PropTypes.bool,
  emptyMessage: PropTypes.instanceOf(FormattedMessage),
};
export default {
  NoDataFound,
  MPMTable,
  SmartTable,
};
